import { getActivePromotions } from "../services/promtionsService";

export const getPromotions = () => dispatch => {
    dispatch({
        type: 'PROMOTIONS_WAITING',
        payload: []
    });

    getActivePromotions()
        .then((promotionsList) => {
            // handle success
            dispatch({
                type: 'PROMOTIONS_SUCCESS',
                payload: promotionsList
            });
        })
        .catch((error) => {
            // handle error
            dispatch({
                type: 'PROMOTIONS_ERROR',
                payload: []
            });
        });
};
